import { render, staticRenderFns } from "./PDFLayout.vue?vue&type=template&id=6a3d6e10"
import script from "./PDFLayout.vue?vue&type=script&lang=js"
export * from "./PDFLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports